import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageHero from "../components/PageHero";
import { VideoCard } from "../components/Cards";
import { getVideos } from "../lib/api";

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [query, setQuery] = useState("");
  const location = useLocation();

  useEffect(() => { getVideos().then(setVideos).catch(() => {}); }, []);
  useEffect(() => {
    const q = new URLSearchParams(location.search).get("q") || "";
    setQuery(q);
  }, [location.search]);

  const list = query
    ? videos.filter((v) => (v.title + " " + (v.description || "") + " " + (v.programName || "")).toLowerCase().includes(query.toLowerCase()))
    : videos;

  return (
    <div>
      <PageHero
        title="Program" highlight="Videoları"
        subtitle="Kaçırdığınız tüm program ve içeriklere video arşivimizden dilediğiniz zaman ulaşın."
        image="https://images.unsplash.com/photo-1594394489098-74ac04c0fc2e"
      />
      <div className="tv-container py-12">
        {query && (
          <p className="text-[var(--tv-muted)] mb-6">
            <span className="text-white font-semibold">"{query}"</span> için {list.length} sonuç bulundu.
          </p>
        )}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {list.map((v, i) => <VideoCard key={v.id} video={v} index={i} linkToDetail />)}
        </div>
        {!list.length && <p className="text-center text-[var(--tv-muted)] py-16">Sonuç bulunamadı.</p>}
      </div>
    </div>
  );
}
